import { type CombinedError, useQuery } from "urql"

import { FULL_LIST_LIMIT } from "@/constants/common"
import type { Product, Query } from "@/graphql/codegen/graphql"
import { ProductListSuggestionDocument } from "@/graphql/codegen/graphql"

interface UseProductsSuggestionListReturn {
  products: Product[]
  fetching: boolean
  error?: CombinedError
}

const useProductsSuggestionList = ({ query }: { query: string }): UseProductsSuggestionListReturn => {
  const [{ data, error, fetching }] = useQuery<Pick<Query, "product">>({
    query: ProductListSuggestionDocument,
    variables: {
      input: {
        filter: {
          query,
        },
        offset: 0,
        limit: FULL_LIST_LIMIT,
      },
    },
    pause: query.length < 2, // Conditionally pause the query
  })
  const products = data?.product?.list?.__typename === "ProductListSuccess" ? data.product.list.products : []
  return {
    products,
    error,
    fetching,
  }
}

export default useProductsSuggestionList
